import { render, staticRenderFns } from "./Consulta.vue?vue&type=template&id=0978d04e&"
import script from "./Consulta.vue?vue&type=script&lang=js&"
export * from "./Consulta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Pipelines\\release\\07.00\\maintenance\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0978d04e')) {
      api.createRecord('0978d04e', component.options)
    } else {
      api.reload('0978d04e', component.options)
    }
    module.hot.accept("./Consulta.vue?vue&type=template&id=0978d04e&", function () {
      api.rerender('0978d04e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/Orcamento/Consulta.vue"
export default component.exports